import * as actions from './../actions/actions';
import { updateObject } from './../../common/utils/utility';

const initialState = {
	token: null,
	adminToken: null,
	userInfo: null,
	error: null,
	loading: false,
	authRedirectPath: '/home',
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actions.AUTH_START:
			return updateObject(state, {
				error: null,
				loading: true,
			});
		case actions.AUTH_SUCCESS:
			return updateObject(state, {
				token: action.idToken,
				adminToken: action.adminToken,
				userInfo: action.userInfo,
				error: null,
				loading: false,
				originalURL: action.originalURL,
			});
		case actions.AUTH_FAIL:
			return updateObject(state, {
				error: action.error,
				loading: false,
			});
		case actions.AUTH_LOGOUT:
			return updateObject(state, {
				token: null,
				adminToken: null,
				userInfo: null,
			});
		case actions.SET_AUTH_REDIRECT_PATH:
			return updateObject(state, {
				authRedirectPath: action.path,
			});
		case actions.CREATE_USER_START:
			return updateObject(state, {
				error: null,
				loading: true,
			});
		case actions.CREATE_USER_SUCCESS:
			return updateObject(state, {
				error: null,
				loading: false,
			});
		case actions.CREATE_USER_FAIL:
			return updateObject(state, {
				error: action.error,
				loading: false,
			});
		case actions.RECOVER_PASSWORD_START:
			return updateObject(state, {
				error: null,
				loading: true,
			});
		case actions.RECOVER_PASSWORD_SUCCESS:
			return updateObject(state, {
				error: null,
				loading: false,
			});
		case actions.RECOVER_PASSWORD_FAIL:
			return updateObject(state, {
				error: action.error,
				loading: false,
			});
		case actions.AUTH_UPDATE_USERINFO:
			return updateObject(state, {
				userInfo: updateObject(state.userInfo, action.updatedInfo),
				error: null,
				loading: false
			});
		default:
			return state;
	}
};

export default reducer;
